import { useTranslation } from 'react-i18next'

import type { CampaignChannel } from '../model/campaign'

interface CampaignChannelBadgesProps {
  channels: CampaignChannel[]
}

/** The SMS / Email chips beside a campaign name. */
export function CampaignChannelBadges({
  channels,
}: CampaignChannelBadgesProps) {
  const { t } = useTranslation()
  return (
    <>
      {channels.map((channel) => (
        <span
          key={channel}
          className="inline-flex shrink-0 items-center rounded-full bg-gray-100 px-2 py-0.75 text-xs font-medium text-gray-500"
        >
          {t(`campaigns.channel.${channel}`)}
        </span>
      ))}
    </>
  )
}
